/* @ngInject */
const openSingleModal = () => {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var modalInstance /* assign to undefined if you like to be explicit */

      element.bind('click', function () {
        if (modalInstance) {
          return
        }

        modalInstance = scope.$eval(attrs.openSingleModal)

        if (!modalInstance || !modalInstance.result || typeof modalInstance.result.then !== 'function') {
          console.error('Incorrect modal instance returned from the open modal function', element, modalInstance)
          return
        }

        modalInstance.result.then(function () {
          modalInstance = undefined
        }, function () {
          modalInstance = undefined
        })
      })
    },
  }
}
export default openSingleModal



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/modals/openSingleModal.js